<template>
  <div class="user_box">
      <el-row>

          <el-col :span="5">
              <el-card class="centerText">
                  <img :src="imgSrc" class="imgStyle" />
                  <p class="user-identity">
                      <i class="el-icon-star-off"></i>

                      欢迎，<strong>{{userInfo.name}}</strong>

                  </p>

                  <br />
                  <p class="user-identity">
                      <strong>
                          <i class="el-icon-medal-1"></i>
                          <i class="el-icon-medal-1"></i>
                          <i class="el-icon-medal-1"></i>
                          诚信服务，合规经营
                          <i class="el-icon-medal-1"></i>
                          <i class="el-icon-medal-1"></i>
                          <i class="el-icon-medal-1"></i>
                      </strong>
                  </p>

                  <br />
                  <p class="user-identity">
                      <i class="el-icon-watch"> </i> 上次登陆时间 : <span>{{userInfo.last_login_time|dateFormat}}</span>
                  </p>
                  <br />
                  <p class="user-identity">
                      <i class="el-icon-location-information"> </i> 上次 登录 IP : <span>{{userInfo.last_login_ip}}</span>
                  </p>

              </el-card>
          </el-col>
          <el-col :span="19">
              <el-card >
                  <el-tabs type="border-card">
                      <el-tab-pane label="基本资料">
                          <el-form>
                              <el-row>
                                  <el-col :span="8">
                                      <el-form-item label="登录账号">
                                          {{userInfo.user_name}}
                                      </el-form-item>
                                  </el-col>
                              </el-row>
                              <el-row>
                                  <el-col :span="8">
                                      <el-form-item label="用户名称">
                                          {{userInfo.name}}
                                      </el-form-item>
                                  </el-col>
                              </el-row>

                              <el-row>
                                  <el-col :span="8">
                                      <el-form-item label="联系方式">
                                          {{userInfo.mobile}}
                                      </el-form-item>
                                  </el-col>
                              </el-row>
                              <el-row>
                                  <el-col :span="8">
                                      <el-form-item label="用户状态">
                                          {{userInfo.status==0?'启用':'禁用'}}
                                      </el-form-item>
                                  </el-col>
                              </el-row>

                          </el-form>


                      </el-tab-pane>
<!--                      <el-tab-pane label="修改密码">-->
<!--                          <el-form :model="pwdForm" :rules="pwdRules" ref="pwdForm" label-width="80px">-->

<!--                              <el-row >-->
<!--                                  <el-col :span="8">-->
<!--                                      <el-form-item label="账号" prop="user_name">-->
<!--                                          <el-input v-model="pwdForm.user_name" readonly autocomplete="off" placeholder="请输入账号"></el-input>-->
<!--                                      </el-form-item>-->
<!--                                  </el-col>-->
<!--                              </el-row>-->
<!--                              <el-row>-->
<!--                                  <el-col :span="8">-->
<!--                                      <el-form-item label="密码" prop="password">-->
<!--                                          <el-input v-model="pwdForm.password" autocomplete="off" placeholder="请输入密码"></el-input>-->
<!--                                      </el-form-item>-->
<!--                                  </el-col>-->
<!--                              </el-row>-->
<!--                              <el-row>-->
<!--                                  <el-col :span="8">-->
<!--                                      <el-form-item label="确认密码" prop="repassword">-->
<!--                                          <el-input v-model="pwdForm.repassword" autocomplete="off" placeholder="请再次输入密码"></el-input>-->
<!--                                      </el-form-item>-->
<!--                                  </el-col>-->
<!--                              </el-row>-->
<!--                              <el-row>-->
<!--                                  <el-col :span="8">-->
<!--                                      <el-button @click="pwdReset_dialogForm('pwdForm')">取 消</el-button>-->
<!--                                      <el-button type="primary" @click="pwdSubmitForm('pwdForm')">确 定</el-button>-->
<!--                                  </el-col>-->
<!--                              </el-row>-->


<!--                          </el-form>-->

<!--                      </el-tab-pane>-->
                  </el-tabs>
              </el-card>
          </el-col>

      </el-row>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data(){
    return {
      status:'开启',
        userInfo:{},
        imgSrc:'https://zkycyd.oss-cn-beijing.aliyuncs.com/public/logo.png',
        pwdForm: {
            user_name: sessionStorage.getItem('userName'),
            password: '',
            repassword: '',
        },
        pwdRules: {
            password: [
                { required: true, message: "请输入密码", trigger: "blur" }
            ],
            repassword: [
                { required: true, message: "请再次输入密码", trigger: "blur" }
            ],
        },
    }
  },
  created() {
    this.userNme = sessionStorage.getItem('userName')
    this.remark = sessionStorage.getItem('remark')
    // this.userNme = sessionStorage.getItem('company_id')
    // this.userNme = sessionStorage.getItem('company_id')
    this.getinfoStatus();
  },
  methods:{
    getinfoStatus(){
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      }
      this.$axios.getEmployeeInfo(param).then(res=>{
        if(res.code == 200){
            this.userInfo = res.data;
            console.log('userInfo',res.data);
          this.status = res.data.status ? '禁用' : '启用'
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error=>{
        //console.log(error);
      })
    },
      //修改密码
      pwdReset_dialogForm(formName) {
          this.dialogPassword = false
          this.$nextTick(() => {
              this.$refs[formName].resetFields()
          })
      },
      pwdSubmitForm(formName) {
          this.$refs[formName].validate((valid) => {
              if (valid) {

                  const param = {
                      id: sessionStorage.getItem('user_id'),
                      password: this.pwdForm.password,
                      repassword: this.pwdForm.repassword,
                      access_token: sessionStorage.getItem('token'),
                      company_id: sessionStorage.getItem('company_id'),
                  }
                  this.$axios.setSYSPassword(param).then(res=>{
                      if(res.code == 200){
                          this.$message.success(res.msg);
                          this.getinfoStatus();
                      }else{
                          this.$message.error(res.msg);
                      }
                  }).catch(error=>{
                      //console.log(error);
                  })

              }
          })
      },
  },
    filters: {
        //时间格式化
        dateFormat(add_time) {
            if (add_time == undefined) {
                return "";
            }
            return moment(add_time*1000).format("yyyy-MM-DD HH:mm:ss");
        },
    }
}

</script>
<style scoped lang="less">
.user_box{
  margin: 0 auto;
}
.centerText{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/view/user/userInfo.vue